module.exports = __webpack_public_path__ + "static/img/235.a6b0f7c2.jpg";